import ProfessionalsWorkJourney from 'presentation/app/modules/Reports/pages/professionals/professionals-work-journey';
import React from 'react';

export const MakeProfessionalsWorkJourney: React.FC = () => {
  return <ProfessionalsWorkJourney />;
};
